/** @format */

import { Component, EventEmitter, Input, Output, computed, inject } from '@angular/core';

import { BreakPointNew } from '@shared/data-access/enums';
import { BreakpointsService } from '@shared/utils/services';
import { ProductReviewAnalyticsService } from '@product-reviews/data-access';

@Component({
    selector: 'product-reviews-load-more-button',
    templateUrl: './review-load-more-button.component.html',
    styleUrls: ['./review-load-more-button.component.scss'],
    standalone: false
})
export class ReviewLoadMoreButtonComponent {
	@Input() displayButton = true;
	@Input() label: string;
	@Input() disabled = false;
	@Input() total = 0;
	@Input() remain = 0;
	@Output() loadMoreClicked: EventEmitter<void> = new EventEmitter();

	private analyticsService = inject(ProductReviewAnalyticsService);
	private readonly breakpointsService = inject(BreakpointsService);

	isMobileSize = computed(() => this.breakpointsService.breakpoint() <= BreakPointNew.MEDIUM);

	loadMoreReviews(): void {
		if (this.disabled) {
			return;
		}

		this.loadMoreClicked.emit();

		this.analyticsService.fireReviewAnalytics<{ event: string; value: string }>({
			name: 'multiUseAnalyticsEvent',
			payload: { event: 'RatingsAndReviewsInteractions', value: 'LoadMoreReviews' }
		});
	}
}
